import { Injectable } from "@angular/core";
import { DwEventService, DwModalButtonStandardConfigs, DwModalConfig, DwModalResult, DwModalService, DwModalSize, DwRoutingService, DwSecurityState, DwSecurityStateService, DwSecurityUserService, DwUser } from "@devwareapps/devware-cap";
import { PilexosUser } from "../models/pilexos-user.model";
import { AdminUserProperties } from "../models/admin-user-properties.model";
import { PilexosUserTypeIds } from "../models/pilexos-user-type.enum";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";
import { Observable, of } from "rxjs";
import { UserTypeSelectionModalComponent } from "../components/user-type-selection-modal/user-type-selection-modal.component";
import { tap } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class AdminManagerService {
    static isInitialized = false;

    static userProperties: AdminUserProperties;
    static lastSecurityState: DwSecurityState;


    constructor(private dwSecurityUserService: DwSecurityUserService,
        private dwSecurityStateService: DwSecurityStateService,
        private dwEventService: DwEventService,
        private dwModalService: DwModalService,
        private dwRoutingService: DwRoutingService
    ) {
        this.setupEvents();
    }

    setupEvents() {

    }

    canUseAdminProperties(): boolean {
        return this.dwSecurityUserService.hasPermission(AppPermissions.pilexosAdmin);
    }

    getPilexosUser(user?: DwUser): PilexosUser {
        if (!user) {
            user = this.dwSecurityUserService.securityState?.securityContext?.ApplicationUser;
        }
        return new PilexosUser(user, this.getAdminUserProperties(new PilexosUser(user, null)));
    }

    getAdminUserProperties(user: PilexosUser): AdminUserProperties {

        if (!this.canUseAdminProperties()) {
            return null;
        }

        let adminUserProperties: AdminUserProperties = AdminManagerService.userProperties;

        if (!AdminManagerService.isInitialized && user?.user?.UserName) {
            adminUserProperties = this.getLocalStorageProperties(user.user.UserName);

            AdminManagerService.userProperties = adminUserProperties;
            AdminManagerService.isInitialized = true;
        }

        if (!adminUserProperties) {
            adminUserProperties = {
                userId: user?.user?.UserId,
                userTypeMode: user?.UserTypeId, // user?.UserTypeId,
                flightSchoolOrganizationId: user?.flightSchoolOrganizationId,
                flightSchoolId: user?.flightSchoolId
            }
        }

        // adminUserProperties.userTypeMode = this.getCurrentUserTypeByPermissions();

        return adminUserProperties;
    }

    public updateAdminProperties(properties: Partial<AdminUserProperties>) {
        if (!this.canUseAdminProperties()) {
            return;
        }

        const existingProperties = this.getAdminUserProperties(new PilexosUser(this.dwSecurityUserService.securityState.securityContext.ApplicationUser, null));

        const updatedProperties = {
            ...existingProperties,
            ...properties
        }

        this.setLocalStorageProperties(this.dwSecurityUserService.securityState.securityContext.ApplicationUser?.UserName, updatedProperties);

        AdminManagerService.userProperties = updatedProperties;

        this.dwSecurityStateService.setSecurityContext({ ...this.dwSecurityUserService.securityState.securityContext, lastUpdated: new Date() } as any);

        setTimeout(() => {
            this.dwRoutingService.navigateToUrl("/");
        }, 50);
    }

    public showUserTypeModal(titleOveride?: string): Observable<DwModalResult> {
        if (!this.canUseAdminProperties()) {
            return of({ cancelled: true } as DwModalResult);
        }

        let modalConfig = new DwModalConfig<PilexosUser>();

        modalConfig.title = titleOveride || "Change User Type";
        modalConfig.component = UserTypeSelectionModalComponent;
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;

        modalConfig.data = this.getPilexosUser();

        // modalConfig.modalSize = DwModalSize.custom;
        // modalConfig.customModalWidth = '600px';
        // modalConfig.customModalHeight = '800px';

        modalConfig.modalSize = DwModalSize.responsive;

        return this.dwModalService.showModal<PilexosUser, AdminUserProperties>(modalConfig)
            .pipe(tap((result) => {
                if (!result.cancelled && result.data) {
                    this.updateAdminProperties(result.data);
                }
            }));
    }

    private getLocalStorageProperties(userName: string): AdminUserProperties {
        const key = `AdminUserProperties-${userName}`;

        let properties = sessionStorage.getItem(key);

        if (properties) {
            try {
                return JSON.parse(properties);
            } catch (e) {
                console.error(e);
                return null;
            }
        }

        return null;
    }

    private setLocalStorageProperties(userName: string, properties: AdminUserProperties) {
        const key = `AdminUserProperties-${userName}`;

        sessionStorage.setItem(key, JSON.stringify(properties));
    }

    private clearLocalStorageProperties(userName: string) {
        const key = `AdminUserProperties-${userName}`;

        sessionStorage.removeItem(key);
    }




}